import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Absolute, CloseButton, Flex, Text } from "pcln-design-system";
import styled_components, { css, keyframes } from "styled-components";
const NotificationBox = /*#__PURE__*/ styled_components(Flex).withConfig({
    displayName: "ChatBotPopOver__NotificationBox"
})([
    "position:fixed;align-items:center;border-radius:6px 12px 20px 24px;cursor:pointer;"
]);
const fadeInFromBottomToTopAnimation = (props)=>{
    const animation = /*#__PURE__*/ keyframes([
        "from{transform:translate(",
        ",",
        ");-webkit-transform:translate(",
        ",",
        ");opacity:0;}to{transform:translate(",
        ",",
        ");opacity:1;}"
    ], props.fromX, props.fromY, props.fromX, props.fromY, props.toX, props.toY);
    return /*#__PURE__*/ css([
        "position:relative;animation:",
        ";animation-duration:0.4s;animation-fill-mode:forwards;animation-timing-function:cubic-bezier(0,0,0.3,1);"
    ], animation);
};
const AnimateBottomToTop = /*#__PURE__*/ styled_components.div.withConfig({
    displayName: "ChatBotPopOver__AnimateBottomToTop"
})([
    "",
    " position:absolute;bottom:0;right:15px;width:100%;height:100%;"
], fadeInFromBottomToTopAnimation);
const AnimateComponent = ({ children, animationProperties, animationType })=>{
    if ('BottomToTopLeft' === animationType || 'RightToLeft' === animationType) {
        const { bottom, from, to } = animationProperties;
        return /*#__PURE__*/ jsx(AnimateBottomToTop, {
            fromX: from.x,
            fromY: from.y,
            toX: to.x,
            toY: to.y,
            bottom: bottom,
            children: children
        });
    }
    return children;
};
function ChatBotPopOver(props) {
    const { onClose, onOpen, onDisplay, text, positionProps, containerProps, animationType = 'None', animationProperties, source, isFrequentNotification } = props;
    const { zIndex, bottom, right } = positionProps ?? {};
    const { width = '300px' } = containerProps ?? {};
    const [hidePopOver, setHidePopOver] = useState(true);
    const today = new Date();
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay());
    startOfWeek.setHours(0, 0, 0, 0);
    useEffect(()=>{
        const homePagePopoverLastSaved = localStorage.getItem('homePagePopoverLastSaved');
        const shouldNotShowHomePagePopOver = localStorage.getItem('shouldNotShowHomePagePopOver');
        const homePagePopoverLastSavedDate = homePagePopoverLastSaved ? new Date(homePagePopoverLastSaved) : null;
        if (isFrequentNotification && homePagePopoverLastSavedDate && shouldNotShowHomePagePopOver) if ('homepage' === source && 'false' === shouldNotShowHomePagePopOver) setHidePopOver(false);
        else if ('homepage' !== source) setHidePopOver(false);
        else if (homePagePopoverLastSavedDate && homePagePopoverLastSavedDate < startOfWeek) {
            localStorage.setItem('shouldNotShowHomePagePopOver', 'false');
            localStorage.setItem('homePagePopoverLastSaved', today.toString());
            setHidePopOver(false);
        } else setHidePopOver(true);
        else setHidePopOver(false);
    }, [
        isFrequentNotification
    ]);
    const handleHomePageClose = ()=>{
        if ('homepage' === source && isFrequentNotification) {
            localStorage.setItem('shouldNotShowHomePagePopOver', 'true');
            localStorage.setItem('homePagePopoverLastSaved', today.toString());
        }
    };
    useEffect(()=>{
        if (false === hidePopOver && 'function' == typeof onDisplay) onDisplay();
    }, [
        hidePopOver,
        onDisplay
    ]);
    if (hidePopOver) return null;
    return /*#__PURE__*/ jsx(AnimateComponent, {
        animationType: animationType,
        animationProperties: animationProperties,
        children: /*#__PURE__*/ jsx(Absolute, {
            bottom: bottom,
            right: right,
            zIndex: zIndex,
            width: width,
            children: /*#__PURE__*/ jsxs(NotificationBox, {
                pt: 3,
                pb: 3,
                px: 3,
                boxShadow: "lg",
                color: "text.base",
                onClick: function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    onOpen();
                },
                children: [
                    /*#__PURE__*/ jsx(Absolute, {
                        bottom: "55px",
                        right: "-10px",
                        children: /*#__PURE__*/ jsx(CloseButton, {
                            "data-testid": "CHATBOT_POPOVER_CLOSEBUTTON",
                            title: "close",
                            variant: "filled",
                            size: "md",
                            onClick: function(e) {
                                e.stopPropagation();
                                e.preventDefault();
                                handleHomePageClose();
                                onClose();
                            }
                        })
                    }),
                    /*#__PURE__*/ jsx(Text, {
                        fontSize: 1,
                        children: text
                    })
                ]
            })
        })
    });
}
export { ChatBotPopOver };
